<template>
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>Waiting</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="checkout.html">Waiting</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div class="container">
		<div class="row" style="justify-content: center">
			<div class="col-6">
				<div class="product-not-found">
					<div class="text-center" v-if="!showTimer">
						<h1>Order Cancelled!</h1>
						<h5>
							Order Cancelled Successfully. Your order ID is : OD-{{ getPlacedOrderId }}-{{
								Date.now()
							}}
						</h5>
						<router-link :to="{name: 'Home'}" class="thank-you-back"
							>Back to homepage</router-link
						>
					</div>
					<div class="not-found" v-if="showTimer">
						<div v-if="timer != 0">
							<h4>Redirecting you on payment gateway in</h4>
							<h2>{{ milliToMinutes }}</h2>
							<h6>You can cancel this order by click on "cancel" button below</h6>
							<button
								type="button"
								class="button button-outline-secondary"
								@click="handleCancel"
								:disabled="loading"
							>
								{{ loading ? "Please Wait.." : "Cancel" }}
							</button>
						</div>
						<div v-else>
							<h4>Please Wait..</h4>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<Footer />
</template>

<script>
	import axios from "axios";
	import Footer from "../components/Bottom/Footer.vue";
	import {mapGetters} from "vuex";
	import {useToast} from "vue-toastification";
	import {publicPath} from "../../vue.config";
	export default {
		components: {Footer},
		data() {
			return {
				timer: 10000,
				showTimer: true,
				interval: "",
				loading: false,
				token: localStorage.getItem("token"),
				order_id: null,
				stripe_url: null,
				base_path: window.location.origin + publicPath + "payment-status",
				script: `https://checkout.razorpay.com/v1/checkout.js`,
				orderObj: null,
			};
		},
		computed: {
			...mapGetters("orders", ["getPlacedOrderId"]),
			milliToMinutes() {
				return this.millisToMinutesAndSeconds(this.timer);
			},
		},
		methods: {
			millisToMinutesAndSeconds(millis) {
				var minutes = Math.floor(millis / 60000);
				var seconds = ((millis % 60000) / 1000).toFixed(0);
				return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
			},
			countDownTimer() {
				if (this.timer > 0) {
					this.interval = setTimeout(() => {
						this.timer -= 1000;
						this.countDownTimer();
					}, 1000);
				}
			},
			handleCancel() {
				clearInterval(this.interval);
				this.ChangeOrderStatus();
			},
			async ChangeOrderStatus() {
				this.loading = true;
				try {
					let {data} = await axios.post(
						process.env.VUE_APP_API_URL + "/api/frontend/update-order-status",
						{order_id: this.order_id, status: 5},
						{
							headers: {
								Authorization: `Bearer ${this.token}`,
							},
						}
					);
					this.showTimer = false;
					this.loading = false;
					console.log(data);
				} catch (error) {
					console.log(error);
					this.showTimer = false;
					this.loading = false;
				}
			},
			async razorpay() {
				console.log("Order details mounted");
				try {
					const params = {
						order_id: this.order_id,
					};
					const url = process.env.VUE_APP_API_URL + "/api/frontend/razorpays";
					let res = await axios.get(url, {
						params,
						headers: {
							Accept: "application/json",
							Authorization: `Bearer ${this.token}`,
						},
					});
					this.orderObj = res.data.payload;
					console.log("this.orderObj");
					console.log(res);
					console.log(this.orderObj);
					//this.created();
				} catch (error) {
					useToast().error(error.response.data.message, {timeout: 3000});
					this.handleCancel(); //cancel order if there is any error
				}
			},
			async loadRazorPay() {
				return new Promise((resolve) => {
					const script = document.createElement("script");
					script.src = this.script;
					script.onload = () => {
						resolve(true);
					};
					script.onerror = () => {
						resolve(false);
					};
					document.body.appendChild(script);
				});
			},
			async _created() {
				const result = await this.loadRazorPay();
				const base_path = this.base_path;
				const cancelUrl = base_path + "/cancel?order_id=" + this.order_id;
				//unable to access state variables so we first storing it here in local var, and then use it below.
				if (!result) {
					alert("Failed to load razorpay script");
					return;
				}
				const options = {
					key: this.orderObj.key,
					amount: this.orderObj.key,
					currency: this.orderObj.currency,
					name: this.orderObj.order_name,
					description: this.orderObj.description,
					order_id: this.orderObj.order_id,
					image: this.orderObj.image,
					handler: async function (response) {
						// It is function executed on success
						// call backend with order id and mark success
						console.log(response.razorpay_payment_id);
						console.log(response.razorpay_order_id);
						console.log(response.razorpay_signature);
						try {
							const params = {
								order_id: response.razorpay_order_id,
								payment_id: response.razorpay_payment_id,
								signature: response.razorpay_signature,
							};
							const token = localStorage.getItem("token");
							let {data} = await axios.post(
								process.env.VUE_APP_API_URL + "/api/frontend/razorpays",
								params,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							);
							window.location.href = base_path + "/success?order_id=" + data.payload.order_id;
							console.log(data);
						} catch (error) {
							console.log(error);
							this.$router.push({path: "/404"});
						}
					},
					modal: {
						ondismiss: function () {
							window.location.href = cancelUrl;
						},
					},
					prefill: {
						name: this.orderObj.name,
						email: this.orderObj.email,
						contact: this.orderObj.contact,
					},
				};
				console.log("options", options);
				const paymentObject = new window.Razorpay(options);
				//when payment is failed
				paymentObject.on("payment.failed", function (response) {
					console.log(response.error.code);
					console.log(response.error.description);
					console.log(response.error.source);
					console.log(response.error.step);
					console.log(response.error.reason);
					console.log(response.error.metadata.order_id);
					console.log(response.error.metadata.payment_id);
				});
				paymentObject.open();
			},
			async createSessionCheckoutOnServer() {
				// stripe payment
				try {
					const params = {
						order_id: this.order_id,
						success_url: this.base_path + "/success?order_id=" + this.order_id,
						cancel_url: this.base_path + "/cancel?order_id=" + this.order_id,
					};
					let {data} = await axios.post(
						process.env.VUE_APP_API_URL + "/api/frontend/checkout-session",
						params,
						{
							headers: {
								Authorization: `Bearer ${this.token}`,
							},
						}
					);
					console.log("Session ID " + data.payload.id, "Session URL " + data.payload.url);
					this.stripe_url = data.payload.url;
				} catch (error) {
					console.log(error);
					this.$router.push({path: "/404"});
				}
			},
		},
		mounted() {
			this.order_id = this.$route.query.order_id;
			//for stripe createSessionCheckoutOnServer
			//this.createSessionCheckoutOnServer();
			//for razorpay call razorpay function below
			this.razorpay();
			this.countDownTimer();
		},
		watch: {
			timer: function (val) {
				if (val == 0) {
					// this.$router.push({ name: "Thankyou" });
					//for stripe windowlocation
					//window.location.href = this.stripe_url;
					// for razorpay open payment pop up below
					this._created();
				}
			},
		},
	};
</script>

<style></style>
